import angular from 'angular';
import providerKeyContacts from './providerKeyContacts';
import './style.scss';

export default angular
  .module('components.providerKeyContacts', [])
  .component('providerKeyContacts', providerKeyContacts).name;
